.loadingPage {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    padding: 2rem;
}

.skeletonContainer {
    width: 100%;
    padding: 1.5rem;
}

.skeletonDefault {
    max-width: 600px;
    margin: 0 auto;
}

/* Skeleton spacing */
.skeletonTitle {
    margin-bottom: 1.5rem;
}

.skeletonText {
    margin-bottom: 1rem;
}

.skeletonTextShort {
    margin-bottom: 1rem;
}

/* Table skeleton */
.skeletonTable {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    background: white;
    padding: 1rem;
    border: 1px solid var(--color-border-light);
}

.skeletonRow {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    padding: 0.75rem 0.5rem;
}

.skeletonHeaderCell {
    display: flex;
    align-items: center;
}

.skeletonCell {
    display: flex;
    align-items: center;
}

/* Card skeleton */
.skeletonCard {
    background: white;
    padding: 2rem;
    border: 1px solid var(--color-border-light);
    max-width: 600px;
    margin: 0 auto;
}
